import actions from './oktaGroups.actions'
import getters from './oktaGroups.getters'
import mutations from './oktaGroups.mutations'

const state = {
  groupList: {}
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
